var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "yxtbiz-kng-scorm-complete-standard color-gray-10 standard-size-14",
    },
    [
      _c("div", [
        _vm._v(
          _vm._s(
            _vm.$t("pc_biz_kng_lbl_class_completion_standard" /**完课标准 */)
          )
        ),
      ]),
      _c("div", { staticClass: "color-gray-7 standard-size-12" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "pc_kng_uplaoder_intro_standard_4" /** 课件发布之后，完课标准无法再次编辑 */
            )
          ) + " "
        ),
      ]),
      _c(
        "yxt-radio-group",
        {
          staticClass: "mt8",
          attrs: { type: "tab-radio" },
          model: {
            value: _vm.type,
            callback: function ($$v) {
              _vm.type = $$v
            },
            expression: "type",
          },
        },
        _vm._l(_vm.completeTypes, function (item) {
          return _c(
            "yxt-radio-button",
            { key: item.value, attrs: { label: item.value } },
            [
              _c(
                "div",
                { staticClass: "yxtbiz-flex-center" },
                [
                  _vm._v("\n        " + _vm._s(item.label) + "\n        "),
                  item.tooltip
                    ? _c(
                        "yxt-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: item.tooltip,
                            placement: "top",
                          },
                        },
                        [
                          _c("yxt-svg", {
                            staticClass: "ml4",
                            attrs: {
                              "icon-class": "question-cirlce-o",
                              width: "16px",
                              height: "16px",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        }),
        1
      ),
      _c("div", { staticClass: "mt8 p16 bg-gray-1" }, [
        _vm.type === "time" || _vm.type === "timeAndContent"
          ? _c(
              "div",
              { staticClass: "yxtbiz-flex-center" },
              [
                _c(
                  "yxtbiz-language-slot",
                  { attrs: { "lang-key": "pc_biz_lbl_studytimepercent" } },
                  [
                    _c(
                      "yxt-select",
                      {
                        staticClass: "yxtbiz-w100",
                        attrs: { slot: "0" },
                        on: { change: _vm.change },
                        slot: "0",
                        model: {
                          value: _vm.percent,
                          callback: function ($$v) {
                            _vm.percent = $$v
                          },
                          expression: "percent",
                        },
                      },
                      [
                        _c("yxt-option", {
                          attrs: { label: "100%", value: 100 },
                        }),
                        _c("yxt-option", {
                          attrs: { label: "95%", value: 95 },
                        }),
                        _c("yxt-option", {
                          attrs: { label: "90%", value: 90 },
                        }),
                        _c("yxt-option", {
                          attrs: { label: "85%", value: 85 },
                        }),
                        _c("yxt-option", {
                          attrs: { label: "80%", value: 80 },
                        }),
                        _c(
                          "div",
                          {
                            attrs: { slot: "fixed-footer" },
                            slot: "fixed-footer",
                          },
                          [
                            _c("yxt-input-number", {
                              staticClass: "yxtbiz-w110",
                              attrs: {
                                size: "small",
                                precision: 0,
                                max: 100,
                                min: 1,
                                formatter: function (value) {
                                  return value ? value + "%" : ""
                                },
                                placeholder: _vm.$t(
                                  "pc_kng_standard_lbl_custom" /** 自定义 */
                                ),
                              },
                              model: {
                                value: _vm.customPercent,
                                callback: function ($$v) {
                                  _vm.customPercent = $$v
                                },
                                expression: "customPercent",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.type === "content" || _vm.type === "timeAndContent"
          ? _c("div", { class: { mt16: _vm.type === "timeAndContent" } }, [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "pc_kng_uplaoder_intro_onlycontentComplete_content" /** 完成课件内容获得学分 */
                    )
                  ) +
                  "\n  "
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }